import AuthorizationApi from "../../../service/AuthorizationService";
import SimpleWarningDialog from "../../../components/SimpleWarningDialog";

export default {
  components: {
    SimpleWarningDialog
  },
  data() {
    return {
      routeArr: [],
      snackbar: false,
      imagePath: require("../../../assets/images/softtech-logo.png"),
      show: false,
      loginSubtext: "",
      username: "",
      password: "",
      domainList: [],
      selectedDomain: undefined,
      loading: false,
      rules: {
        required: value => !!value || this.$t("validation_required"),
        min: v =>
          v.length >= 6 ||
          this.$t("validation_minimum_character", { length: "6" })
      },
      captchaValue: "",
      captchaSrc: "",
      loginErrorText: ""
    };
  },
  watch: {
    selectedDomain: function (value) {
      this.$store.dispatch("setUser", {
        domainId: value
      });
    }
  },
  mounted() {
    AuthorizationApi.getAllDomains(
      this,
      response => {
        if (response != null) {
          this.domainList = response.domains;
          this.selectedDomain = response.domains[0].id || 1;
        }
      },
      err => {
        console.log("Error While Getting Domains");
      }
    );
  },
  methods: {
    async login() {
      this.loading = true;
      const authenticated = await this.authenticateUser();
      this.loading = false;

      if (authenticated) {
        const menu = await this.fetchMenu();
        this.routeJSON(menu);
        this.$store.dispatch("setAllowedRoutes", this.routeArr);
        this.$store.dispatch("setNavigationMenu", menu);

        let defaultLoginRoute = { path: "/onboarding" };

        if (menu && menu.length > 0) {
          const firstMenuItem = menu[0];
          if (firstMenuItem && firstMenuItem.children) {
            const availableMenuItems = firstMenuItem.children.filter(
              item => item.menuItem === true
            );
            if (availableMenuItems && availableMenuItems.length > 0) {
              defaultLoginRoute.path = availableMenuItems[0].path;
            }
          }
        }
        const startLocation = this.$router.history._startLocation;
        if (startLocation && startLocation !== '/' && startLocation !== '/onboarding') {
          const isValidRoute = menu.some(route => route.path === startLocation);
          if (isValidRoute) {
            defaultLoginRoute.path = startLocation;
          }
        }

        this.$router.push(defaultLoginRoute.path).catch(error => {
          console.info(error.message);
        });
      }
    },
    authenticateUser: function () {
      let vm = this;
      var bodyFormData = `user=${this.username}&password=${encodeURIComponent(
        this.password
      )}&domainId=${this.selectedDomain}`;
      if (this.captchaValue) {
        bodyFormData += `&captcha=${this.captchaValue}`;
      }
      return new Promise(resolve => {
        AuthorizationApi.authenticateUser(
          this,
          response => {
            this.$cookies.set("authenticated", true, "8h");
            this.$store.dispatch("setUser", {
              id: response.userId,
              name: response.userName,
              domainId: response.domainId,
              domainCode: vm.domainList.find(x => x.id == response.domainId)
                .name,
              domainName: vm.$t(
                vm.domainList.find(x => x.id == response.domainId).name
              ),
              unitCode: response.institutionUnit
            });
            resolve(true);
          },
          err => {
            const { responseMessage } = err.response.data;
            if (
              err.response &&
              err.response.data &&
              (responseMessage ===
                "RallyAuthenticationFailureException : Captcha Does Not Match" ||
                responseMessage ===
                "RallyAuthenticationFailureException : Must Enter Captcha" ||
                responseMessage.startsWith(
                  "RallyAuthenticationFailureException : User Authentication Failed"
                ))
            ) {
              if (this.captchaSrc) {
                this.loginErrorText = this.$t(
                  "username_or_password_or_captcha_invalid"
                );
              } else {
                this.loginErrorText = this.$t("username_or_password_invalid");
              }
              this.snackbar = true;
              this.captcha();
              this.captchaValue = "";
            } else if (
              responseMessage ===
              "RallyAuthenticationFailureException : User Authentication Failed,User does not belong to given domain"
            ) {
              this.loginErrorText = this.$t("invalid_domain");
              this.snackbar = true;
            }
            resolve(false);
          },
          bodyFormData
        );
      });
    },
    captcha() {
      var xhr = new XMLHttpRequest();
      var self = this;
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var url = window.URL || window.webkitURL;
          self.captchaSrc = url.createObjectURL(this.response);
          console.log("RESULT:", this.captchaSrc);
        }
      };
      xhr.open(
        "GET",
        "/services/authorization/api/authentication/authenticate/" +
        this.username +
        "/generateCaptcha"
      );
      xhr.setRequestHeader(
        "Accept",
        "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9"
      );
      xhr.responseType = "blob";
      xhr.send();
    },
    fetchMenu: function () {
      return new Promise(resolve => {
        AuthorizationApi.fetchMenu(this, response => {
          resolve(response.resultList);
        });
      });
    },
    routeJSON(list) {
      if (list != null) {
        for (const item of list) {
          if (item.component != null) {
            this.routeArr.push({
              name: item.name,
              path: item.path,
              component: item.component
            });
          } else {
            this.routeArr.push({
              name: item.name,
              path: item.path,
              component: "PageTemplate"
            });
          }
          if (item.children != null && item.children.length > 0) {
            this.routeJSON(item.children);
          }
        }
      }
    },
    closeWarningDialog() {
      this.snackbar = false;
    },
    onPasteUsername(event) {
      this.username = (event.clipboardData || window.clipboardData)
        .getData("text")
        .trim();
      event.preventDefault();
    },
    onPastePassword(event) {
      this.password = (event.clipboardData || window.clipboardData)
        .getData("text")
        .trim();
      event.preventDefault();
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/authorization/mixin/Login.js